<template>
	<div>
		
		<baidu-map style="width: 77%;" @ready="handler" @click="site" scroll-wheel-zoom class="map" center="北京">
			<el-input placeholder="请输入搜索地址" v-model="keyword" class="input-with-select">
			  <el-button slot="append" icon="el-icon-search"></el-button>
			</el-input>
			<label> 当前位置：{{locData.latitude}},{{locData.longitude}} 当前位置：{{locData.address}}</label>
			
			<bm-marker :position="positionIcon" :dragging="true" animation="BMAP_ANIMATION_BOUNCE">
				<bm-label :content="content" :labelStyle="{ color: 'red', fontSize: '24px' }" :offset="{ width: 8, height: 20 }" />
				<!-- 地区检索 -->
				<bm-local-search :keyword="keyword" :auto-viewport="true"></bm-local-search>
				<!-- 缩放 -->
				<bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
				<!-- 比例尺 -->
				<bm-scale anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-scale>
				<!-- 城市 -->
				<bm-city-list anchor="BMAP_ANCHOR_TOP_LEFT"></bm-city-list>
				<!-- 定位 -->
				<bm-geolocation @locationSuccess="locationSuccess" anchor="BMAP_ANCHOR_BOTTOM_RIGHT" :showAddressBar="true" :autoLocation="true"></bm-geolocation>
			</bm-marker>
			<bm-map-type :map-types="['BMAP_NORMAL_MAP', 'BMAP_HYBRID_MAP']" anchor="BMAP_ANCHOR_TOP_LEFT"></bm-map-type>
		</baidu-map>
	</div>
</template>
<script>
export default {
	data() {
		return {
			content: '',
			positionIcon: {},
			keyword: '',
			siteAddress:'',
			city:'',
			province:'',
			district:'',
			street:'',
			map:null,
			locData:{
				longitude:'',
				latitude:'',
				address:'',
			},
		};
	},
	 // 接受父组件的值
	    props: {
	      longitude: Object,
	      latitude: Object
	    },
	
	mounted() {
		console.log(longitude)
		console.log(latitude)
	},
	methods: {	
		 handler ({BMap, map}) {
			//console.log(BMap, map)
		},
		site(e) {
			this.positionIcon = e.point;
			this.province = e.currentTarget.Xg;
			// let Icon_0 = new BMap.Icon("http://cdn.diqwl.com/store_banner_site.png", new BMap.Size(64, 64), {anchor: new BMap.Size(18, 32),imageSize: new BMap.Size(36, 36)});
			// var myMarker = new BMap.Marker(new BMap.Point(e.point.lng, e.point.lat),{icon: Icon_0});
			// map.addOverlay(myMarker);
			//用所定位的经纬度查找所在地省市街道等信息
			var point = new BMap.Point(e.point.lng, e.point.lat);
			var gc = new BMap.Geocoder();
			let _this = this;
			gc.getLocation(point, function (rs) {
				var addComp = rs.addressComponents;
				//console.log(rs.address);//地址信息
				_this.locData.address = rs.address;

			});
			this.locData.longitude = e.point.lng;
			this.locData.latitude = e.point.lat;
			
			this.$emit('localhostMap',this.locData);
			
			//console.log(this.locData)
			
			
		},
		locationSuccess(point, AddressComponent, marker){
			//console.log(point)
			this.province = point.AddressComponent.province+" "+point.AddressComponent.city;
		}
	}
};
</script>
<style>
.map {
	height: 350px;
	width: 700px;
}
</style>
